<app-template-number [disabled]="disabled" [characters]="characters" [value]="value" [min]="min" [max]="max" [required]="required" [control]="control" [label]="label" />
